import { render, staticRenderFns } from "./SituacoesCadastro.vue?vue&type=template&id=4d50a083&scoped=true&"
import script from "./SituacoesCadastro.vue?vue&type=script&lang=js&"
export * from "./SituacoesCadastro.vue?vue&type=script&lang=js&"
import style0 from "./SituacoesCadastro.vue?vue&type=style&index=0&id=4d50a083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50a083",
  null
  
)

export default component.exports